import { useState } from 'react';
import img1 from './Image/fact-sample.png'
import img2 from './Image/fact-sample1.png'
import img3 from './Image/fact-sample2.png'
import './index.css';

const data = [
    {
        topic: 'Snakes',
        fact: 'Snakes Smell With Tongue',
        picture: img1,
    },
    {
        topic: 'Cats',
        fact: 'Super Swiveling Ears',
        picture: img2,
    },
    {
        topic: 'Dogs',
        fact: 'Dogs Smell Time',
        picture: img3,
    },

]

const ContentFactOfTheDay = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div className='text-white'>
            {
                data.map((item, index) => <div className='mb-5' key={index}>
                    <p className='fw-bold text-center'>Topic: {item.topic}</p>
                    <p className='text-center'><span className='fw-bold'>Fact:</span> {item.fact}</p>
                    <img
                        className='imgeAI-image mx-auto d-block'
                        src={item.picture}
                        alt={item.topic}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedImage(item.picture);
                        }}
                        style={{
                            cursor: "pointer",
                            transition: "transform 0.2s",
                        }}
                        onMouseEnter={(e) => e.target.style.transform = "scale(1.02)"}
                        onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                    />
                </div>)
            }

            {/* Lightbox Modal */}
            {selectedImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "12px",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "20px",
                            right: "30px",
                            color: "#fff",
                            fontSize: "30px",
                            cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(null)}
                    >
                        ✕
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContentFactOfTheDay;